import { Map } from 'immutable'
import React from 'react'
import { Action, AsyncState, IOWidget, mk_widget, Pair } from 'widgets-for-react'
import { ImageSize } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { ImageContainer } from '../../../../cms/blocks/widgets/ImageContainer.gen'
import { TemplateState } from '../../../../cms/page/types.gen'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { CustomBlockData } from '../types.mod'
import { DataLayer } from '../../../utils/datalayer'

export type BSLContactPersonBlockProps<customBlockData, extra_images> = {
  title: string
  function: string
  name: string
  email?: string
  phone?: string
  image?: number
  image_size?: ImageSize<extra_images>
  image_alt?: string
  get_default_data_src: () => ImageSize<extra_images>
  get_default_data_srcset: () => Array<Pair<ImageSize<extra_images>, string>>
}

export type BSLContactPersonBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  content_classname: string
  title_classname: string
  subtitle_classname: string
  function_classname: string
  name_classname: string
  figure_classname: string
  image_classname: string
  buttons_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function BSLContactPersonBlock<customBlockData, extra_images>(
  props: BSLContactPersonBlockProps<customBlockData, extra_images>,
  options?: { style?: BSLContactPersonBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => (
        <>
          <section
            className={getClassName(options, 'block_classname', 'block')}
            key={options && options.key ? options.key : ''}
          >
            <div className={getClassName(options, 'inner_classname', '')}>
              {s.images.has(props.image) ? (
                <figure className={getClassName(options, 'figure_classname', 'w-100')}>
                  {ImageContainer(
                    s.images.get(props.image) as AsyncState<Map<ImageSize<extra_images>, string>>,
                    props.image_size,
                    getClassName(options, 'image_classname', 'w-100'),
                    props.image_alt,
                    props.get_default_data_src,
                    props.get_default_data_srcset
                  ).run(_ => {})}
                </figure>
              ) : null}
              <div className={getClassName(options, 'content_classname', '')}>
                <h2 className={getClassName(options, 'title_classname', '')}>{props.title}</h2>
                <p className={getClassName(options, 'subtitle_classname', '')}>
                  <span className={getClassName(options, 'name_classname', '')}>{props.name}</span>
                  <span> - </span>
                  <span className={getClassName(options, 'function_classname', '')}>{props.function}</span>
                </p>
                <div className={getClassName(options, 'buttons_classname', '')}>
                  {props.phone && (
                    <a
                      href={`tel:${props.phone.replace(/[\D]/g, '')}`}
                      className={getClassName(options, 'clickable_primary_classname', '')}
                      onClick={() => DataLayer.clickOnContact('Call')}
                    >
                      <svg aria-hidden="true" width="10" height="17">
                        <use xlinkHref="#icon--phone" />
                      </svg>
                      {props.phone}
                    </a>
                  )}
                  {props.email && (
                    <a
                      href={`mailto:${props.email}`}
                      className={getClassName(options, 'clickable_secondary_classname', '')}
                      onClick={() => DataLayer.clickOnContact('Mail')}
                    >
                      <svg aria-hidden="true" width="12" height="9">
                        <use xlinkHref="#icon--mail" />
                      </svg>
                      <span>{props.email}</span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </section>
        </>
      )
    })
}
